export default function Technology() {
  return (
    <section id="technology" className="py-24 bg-gradient-to-b from-cyan-50 to-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-20 left-20 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-cyan-400 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <p className="text-blue-500 font-semibold text-sm uppercase tracking-wider mb-2">TECHNOLOGY</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">ウルトラファインバブル水とは？</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="grid grid-cols-2 gap-4">
            <div className="transform hover:scale-105 transition-transform duration-300">
              <img
                src="https://ufbdual.com/wp-content/uploads/2021/12/Screen-Shot-2021-12-10-at-1.32.18.jpg"
                alt="ウルトラファインバブル"
                className="w-full h-64 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div className="transform hover:scale-105 transition-transform duration-300 mt-8">
              <img
                src="https://ufbdual.com/wp-content/uploads/2021/01/top_topics02.jpg"
                alt="ナノバブル技術"
                className="w-full h-64 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div className="transform hover:scale-105 transition-transform duration-300 -mt-8">
              <img
                src="https://ufbdual.com/wp-content/uploads/2021/01/top_topics03.jpg"
                alt="水の浄化"
                className="w-full h-64 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div className="transform hover:scale-105 transition-transform duration-300">
              <img
                src="https://ufbdual.com/wp-content/uploads/2021/01/top_topics04.jpg"
                alt="清潔な水"
                className="w-full h-64 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>

          <div>
            <div className="bg-white p-8 rounded-2xl shadow-xl">
              <p className="text-gray-700 leading-relaxed mb-6">
                0.000001mmの泡を想像できますか？ウルトラファインバブルの泡1つを100万個並べても約1ミリにしかなりません。顕微鏡でも確認できないほど小さな泡。これがウルトラファインバブルの泡の大きさです。
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                通常の水の気泡は約8秒間で水面に浮上し消滅しますが、ウルトラファインバブルは約1〜2年の間、水中にとどまることが可能です。日本国内の最新テクノロジーとして、環境・農業・食品・水産・美容・医療などさまざまな分野において応用・実用化が進んできました。
              </p>

              <div className="grid grid-cols-3 gap-4 mt-8">
                <div className="text-center p-4 bg-blue-50 rounded-xl">
                  <div className="text-3xl text-blue-500 mb-2">
                    <i className="ri-drop-line"></i>
                  </div>
                  <p className="text-xs text-gray-600 font-semibold">洗浄力向上</p>
                </div>
                <div className="text-center p-4 bg-blue-50 rounded-xl">
                  <div className="text-3xl text-blue-500 mb-2">
                    <i className="ri-heart-pulse-line"></i>
                  </div>
                  <p className="text-xs text-gray-600 font-semibold">美容効果</p>
                </div>
                <div className="text-center p-4 bg-blue-50 rounded-xl">
                  <div className="text-3xl text-blue-500 mb-2">
                    <i className="ri-shield-check-line"></i>
                  </div>
                  <p className="text-xs text-gray-600 font-semibold">清浄化</p>
                </div>
              </div>
            </div>

            <div className="mt-6 text-center">
              <a
                href="#about"
                className="inline-block bg-blue-500 text-white px-8 py-3 rounded-full hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                詳しい特徴を見る
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
